import { LoadableAfterPaint } from '@confluence/loadable';

// TODO: should rename this entire directory to /TemplateCollections/*
//   see https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/56949/overview
export const TemplateCollectionsLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplateCollections" */ './CreateFromTemplate.tsx'))
			.TemplateCollections,
});
